import { useState, useEffect } from 'react';

export const useAvailableMenuWidth = (containerSelector: string, menuClassName: string): number => {
  // Initialized to Infinity to prevent a 1-frame layout shift before initial measurement.
  const [availableWidth, setAvailableWidth] = useState(Infinity);

  useEffect(() => {
    const container = document.querySelector(containerSelector) as HTMLElement;
    if (!container) return;

    const calculateWidth = () => {
      const children = Array.from(container.children) as HTMLElement[];
      let occupiedWidth = 0;

      children.forEach((child) => {
        if (!child.classList.contains(menuClassName)) {
          occupiedWidth += child.offsetWidth;
        }
      });

      const totalWidth = container.clientWidth;
      const remaining = totalWidth - occupiedWidth;
      setAvailableWidth(remaining);
    };

    const resizeObserver = new ResizeObserver(() => calculateWidth());

    resizeObserver.observe(container);
    Array.from(container.children).forEach((child) => resizeObserver.observe(child));
    calculateWidth();

    return () => {
      resizeObserver.disconnect();
    };
  }, [containerSelector, menuClassName]);

  return availableWidth;
};
